import { Injectable } from "@angular/core";
import { AbstractService } from "./abstract.service";
import { HttpClient } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { CreateContatoDto } from "../dto/create-contato.dto";
import { CreateAnuncieImovelDto } from "../dto/create-anuncie-imovel.dto";
import { CreateReembolsoDto } from "../dto/create-reembolso.dto";
import { CreateConstentacaoVistoriaDto } from "../dto/create-constentacao-vistoria.dto";
import { CreateAvisoDesocupacaoDto } from "../dto/create-aviso-desocupacao.dto";
import { CreateTrabalheConoscoDto } from "../dto/create-trabalhe-conosco.dto";

@Injectable({
	providedIn: "root",
})
export class ContatoService extends AbstractService {
	private readonly URL = `${this.API_REST}/contato`;

	constructor(http: HttpClient) {
		super(http);
	}

	async enviarEmail(contatoDto: CreateContatoDto) {
		let formData = new FormData();

		// Adiciona os campos do DTO ao FormData
		for (const [key, value] of Object.entries(contatoDto)) {
			if (value !== null && value !== undefined) {
				formData.append(key, value instanceof File ? value : String(value));
			}
		}

		const response$ = this.http.post<boolean>(this.URL, formData, {});
		return await firstValueFrom(response$);
	}

	async criarAnuncieImovel(criarAnuncieDto: CreateAnuncieImovelDto) {
		const url = this.API_REST + "/venda-alugue-imovel";

		const response$ = this.http.post<boolean>(url, criarAnuncieDto);
		return await firstValueFrom(response$);
	}

	async criarReembolso(params: CreateReembolsoDto) {
		const url = this.API_REST + "/area-do-cliente/reembolso";

		const response$ = this.http.post<boolean>(url, params);
		return await firstValueFrom(response$);
	}

    async criarContestacaoVistoria(params: CreateConstentacaoVistoriaDto) {
        const url = this.API_REST + '/area-do-cliente/contestacao-vistoria';

        const response$ = this.http.post<boolean>(url, params);
        return await firstValueFrom(response$);    
    }

    async criarAvisoDesocupacao(params: CreateAvisoDesocupacaoDto) {
        const url = this.API_REST + '/area-do-cliente/aviso-desocupacao';

        const response$ = this.http.post<boolean>(url, params);
        return await firstValueFrom(response$);  
    }

	   async enviarTrabalhoConosco(params: FormData) {
        const url = this.API_REST + '/trabalhe-conosco';

        const response$ = this.http.post<boolean>(url, params);
        return await firstValueFrom(response$);  
    }
}
